"use client"

import styles from "./Badge.module.css"

const Badge = ({ children, variant = "default", size = "medium", dot = true, ...props }) => {
  const badgeClasses = [styles.badge, styles[variant], styles[size]].filter(Boolean).join(" ")

  return (
    <span className={badgeClasses} {...props}>
      {dot && <span className={styles.dotIndicator}></span>}
      {children}
    </span>
  )
}

export default Badge
